const BRANDS = ["LG", "GE", "GE PROFILE", "GE CAFE", "WHIRLPOOL", "SAMSUNG"];

const slug = (b) => "brand-marquee-item-" + b.toLowerCase().replace(/\s+/g, "-");

export default function BrandMarquee() {
    return (
        <section className="border-y border-white/10 bg-ink2/40 py-7 overflow-hidden" aria-label="Brands we carry">
            <div className="marquee-track flex w-max">
                {[0, 1].map((group) => (
                    <div key={group} aria-hidden={group === 1} className="flex items-center shrink-0">
                        {BRANDS.map((b) => (
                            <span key={b} className="flex items-center">
                                <span
                                    data-testid={slug(b)}
                                    className="mx-8 md:mx-14 font-display text-3xl md:text-5xl font-bold tracking-tight text-white/25 hover:text-gold transition-colors duration-300 whitespace-nowrap"
                                >
                                    {b}
                                </span>
                                <svg className="h-3 w-3 text-gold shrink-0" viewBox="0 0 10 10">
                                    <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" fill="currentColor" />
                                </svg>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
